import { Helmet } from 'react-helmet';

const SEOHead = ({ 
  title = "Sagre Italia - Il portale delle Sagre d'Italia",
  description = "Trova sagre, feste paesane ed eventi gastronomici in tutta Italia. Cerca per regione, provincia o vicino a te.",
  keywords = "sagre, Italia, feste, eventi gastronomici, tradizioni, cibo italiano, porchetta, tartufo, pesce",
  image = "https://images.unsplash.com/photo-1578655230260-0a9dfa97fc1d?auto=format&fit=crop&w=1200&q=80",
  url,
  type = "website",
  sagra = null
}) => {
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
  const pageUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  
  // If sagra data is provided, use it for SEO
  if (sagra) {
    title = `${sagra.nome} - ${sagra.comune}, ${sagra.provincia} | Sagre Italia`;
    description = `${sagra.descrizione.slice(0, 155)}...`;
    keywords = `${sagra.nome}, sagra ${sagra.comune}, ${sagra.specialita?.join(', ') || ''}, ${sagra.regione}`;
    if (sagra.immagine_url) image = sagra.immagine_url;
    type = "article";
  }

  const structuredData = sagra ? {
    "@context": "https://schema.org",
    "@type": "Event",
    "name": sagra.nome,
    "description": sagra.descrizione,
    "startDate": sagra.data_inizio,
    "endDate": sagra.data_fine,
    "location": {
      "@type": "Place",
      "name": sagra.indirizzo,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": sagra.comune,
        "addressRegion": sagra.provincia,
        "addressCountry": "IT"
      },
      ...(sagra.coordinate && {
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": sagra.coordinate.lat,
          "longitude": sagra.coordinate.lng
        }
      })
    },
    "image": sagra.immagine_url,
    "organizer": sagra.contatti?.nome_organizzatore ? {
      "@type": "Organization",
      "name": sagra.contatti.nome_organizzatore
    } : undefined,
    ...(sagra.valutazione_media > 0 && {
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": sagra.valutazione_media,
        "reviewCount": sagra.numero_recensioni
      }
    })
  } : {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Sagre Italia",
    "description": "Il portale delle Sagre d'Italia - Trova eventi gastronomici e feste paesane",
    "url": baseUrl,
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${baseUrl}/cerca?q={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={pageUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Sagre Italia" />
      <meta property="og:locale" content="it_IT" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={pageUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="geo.region" content="IT" />
      <meta name="geo.placename" content="Italia" />
      <html lang="it" />
    </Helmet>
  );
};

export default SEOHead;
